import { useState } from 'react';
import { useBeforeMount } from '@core/hooks';

const xSmallMedia = window.matchMedia('(max-width: 599.99px)');
const smallMedia = window.matchMedia(
  '(min-width: 600px) and (max-width: 959.99px)'
);
const mediumMedia = window.matchMedia(
  '(min-width: 960px) and (max-width: 1279.99px)'
);
const largeMedia = window.matchMedia('(min-width: 1280px)');

export interface ScreenSize {
  isXSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
}

const getScreenSize = (): ScreenSize => ({
  isXSmall: xSmallMedia.matches,
  isSmall: smallMedia.matches,
  isMedium: mediumMedia.matches,
  isLarge: largeMedia.matches
});

export const useScreenHandler = () => {
  const [screenSize, setScreenSize] = useState(getScreenSize());

  useBeforeMount(() => {
    [xSmallMedia, smallMedia, mediumMedia, largeMedia].forEach((media) => {
      media.addListener((e) => {
        if (e.matches) {
          setScreenSize(getScreenSize());
        }
      });
    });
  });

  return screenSize;
};

export const useScreenSizeClass = (screenSize: ScreenSize) => {
  if (screenSize.isLarge) {
    return 'screen-large';
  }

  if (screenSize.isMedium) {
    return 'screen-medium';
  }

  if (screenSize.isSmall) {
    return 'screen-small';
  }

  return 'screen-x-small';
};
